// src/lib/router.js
// Tiny hash-free in-memory router. View registry + navigate() function.

import { state } from './store.js';

export const views = {};
export const viewHandlers = {};
let currentView = 'dashboard';
let currentParams = null;

export function getCurrentView() { return currentView; }
export function getCurrentParams() { return currentParams; }

export function registerView(name, render, handler) {
  views[name] = render;
  if (handler) viewHandlers[name] = handler;
}

export function navigate(view, params) {
  currentView = view;
  currentParams = params || null;
  document.querySelectorAll('nav.nav button').forEach(b => {
    b.classList.toggle('active', b.dataset.view === view);
  });
  render();
}

export function render() {
  const main = document.getElementById('main');
  if (!main) return;
  const fn = views[currentView] || views.dashboard;
  main.innerHTML = fn(currentParams);

  // counts in sidebar
  const set = (id, v) => { const el = document.getElementById(id); if (el) el.textContent = v; };
  set('ct-companies', state.companies.length);
  set('ct-contacts', state.contacts.length);
  set('ct-deals', state.deals.length);
  set('ct-tickets', state.tickets.length);
  set('ct-activities', state.activities.length);
  set('ct-tasks', state.activities.filter(a => a.type === 'task' && !a.done).length);

  if (viewHandlers[currentView]) viewHandlers[currentView](currentParams);
  window.scrollTo(0, 0);
}
